import { FormEvent } from "react";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { IBuscaUsuarioStore } from "..";
import { UsuarioLista } from "../../../interface/user";

import apiUsuario from "../../../services/apiUsuario";

export interface IBuscaUsuarioModuleStore {
  resultado: UsuarioLista[];
  buscaUsuario(
    selectedOption: string,
    search: string,
    e?: FormEvent
  ): Promise<void>;
  limparBusca(): void;
}

export default (set: SetState<IBuscaUsuarioStore>) =>
  ({
    resultado: [],
    async buscaUsuario(selectedOption, search, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        // const response = await apiUsuario.get(
        //   `userBy/?${selectedOption}=${search}`,
        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //     },
        //   },
        // )
        const response = await apiUsuario.get(
          `userBy/?${selectedOption}=${search}`,
          {
            headers: {
              Authorization: `Bearer ${storedToken}`,
            },
          }
        );
        if (response.status === 200) {
          set((state) => ({
            ...state,
            global: {
              ...state.global,
              loading: false,
            },
            buscarUsuario: {
              ...state.buscarUsuario,
              resultado: response.data,
            },
          }));
        }
        if (response.status === 400) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 401) {
          toast.error(
            "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
          // logout()
        }
        if (response.status === 404) {
          toast.error(`${response.data.message}`, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });

          set((state) => ({
            buscarUsuario: {
              ...state.buscarUsuario,
              resultado: [],
            },
          }));
        }
        if (response.status === 500 || response.status === 503) {
          toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        }
        if (response.status === 504) {
          toast.error(
            "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
            {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            }
          );
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparBusca() {
      set((state) => ({
        ...state,
        buscarUsuario: {
          ...state.buscarUsuario,
          resultado: [],
        },
      }));
    },
  } as IBuscaUsuarioModuleStore);
